import {Pipe, PipeTransform} from '@angular/core';

/**
 * This pipe handles removing whitespaces.
 */
@Pipe({
  name: 'removeWhiteSpace',
})
export class RemoveWhiteSpacePipe implements PipeTransform {

  /**
   * Removes whitespaces from the given text.
   * @param value the text which needs removing whitespaces.
   */
  transform(value: string): string {
    if (value === undefined) {
      return 'undefined';
    }
    return value.replace(/\s/g, '');
  }
}
